<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Repositories from '@/repositories';
const SingleConfigRepository = Repositories.get('singleconfigs');
import HeaderContentLayout from '@/router/layouts/header-content-layout';
import Tooltip from '@/components/widgets/errors/validations-tooltip.vue';
import { required, integer, minValue } from 'vuelidate/lib/validators';
import FilesImports from './components/files-imports.vue';

export default {
  page: {
    title: 'Importations',
  },
  components: {
    Loading,
    HeaderContentLayout,
    Tooltip,
    FilesImports,
  },
  data() {
    return {
      isLoading: false,
      excelConfig: null,
      defaultConfig: {
        linesToIgnore: 0,
        lineImportFlag: 0,
        workOrderName: 0,
        workOrderGroupItems: false,
        itemCode: 0,
        itemCADCAMCode: 0,
        itemAccountingCode: 0,
        itemName: 0,
        itemQuantity: 0,
        itemQuantityInWorkOrder: 0,
        itemMinQuantity: 0,
        itemLotQuantity: 0, // <-- missing
        itemMinOrderQuantity: 0,
        itemCategoryType: 0,
        itemCategory: 0,
        itemUnitType: 0,
        itemQuantityType: 0,
        supplierName: 0,
        supplierLink: 0,
        supplierPaymentMethod: 0,
        supplierPaymentCondition: 0,
        supplierAddress: 0,
        itemSupplierCode: 0,
        itemSupplierName: 0,
        itemSupplierPrice: 0,
        itemSupplierUnitName: 0,
        itemSupplierOrderUnitQuantity: 0,
        itemSupplierOrderMinimumQuantity: 0,
        itemSupplierDeliveryDelay: 0,
        itemSupplierContact: 0,
        itemSupplierPhone: 0,
        itemSupplierEmail: 0,
        itemSupplierCommMethod: 0,
        itemSupplierCommLanguage: 0,
        itemSupplierLink: 0,
      },
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;
      SingleConfigRepository.get('ExcelConfig')
        .then((response) => {
          this.excelConfig = { ...this.defaultConfig, ...response.data };
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 404) {
            this.createConfig();
          } else {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
          }
          this.isLoading = false;
        });
    },
    createConfig() {
      this.excelConfig = { ...this.defaultConfig };
    },
    saveConfig() {
      this.$v.excelConfig.$touch();

      if (!this.$v.excelConfig.$invalid) {
        this.isLoading = true;
        SingleConfigRepository.update(
          { jsonString: JSON.stringify(this.excelConfig) },
          'ExcelConfig'
        )
          .then((resp) => {
            this.excelConfig = resp.data;
            this.isLoading = false;
            this.$toast.successToast(this.$t('general.saved'));
          })
          .catch(() => {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
            this.isLoading = false;
          });
      }
    },
  },
  validations() {
    return {
      excelConfig: {
        linesToIgnore: { required, integer, minValue: minValue(0) },
        lineImportFlag: { required, integer, minValue: minValue(0) },
        workOrderName: { required, integer, minValue: minValue(0) },
        workOrderGroupItems: { required },
        itemCode: { required, integer, minValue: minValue(0) },
        itemCADCAMCode: { required, integer, minValue: minValue(0) },
        itemAccountingCode: { required, integer, minValue: minValue(0) },
        itemName: { required, integer, minValue: minValue(0) },
        itemQuantity: { required, integer, minValue: minValue(0) },
        itemQuantityInWorkOrder: { required, integer, minValue: minValue(0) },
        itemMinQuantity: { required, integer, minValue: minValue(0) },
        itemLotQuantity: { required, integer, minValue: minValue(0) },
        itemMinOrderQuantity: { required, integer, minValue: minValue(0) },
        itemCategoryType: { required, integer, minValue: minValue(0) },
        itemCategory: { required, integer, minValue: minValue(0) },
        itemUnitType: { required, integer, minValue: minValue(0) },
        itemQuantityType: { required, integer, minValue: minValue(0) },
        supplierName: { required, integer, minValue: minValue(0) },
        supplierLink: { required, integer, minValue: minValue(0) },
        supplierPaymentCondition: { required, integer, minValue: minValue(0) },
        supplierPaymentMethod: { required, integer, minValue: minValue(0) },
        supplierAddress: { required, integer, minValue: minValue(0) },
        itemSupplierCode: { required, integer, minValue: minValue(0) },
        itemSupplierName: { required, integer, minValue: minValue(0) },
        itemSupplierPrice: { required, integer, minValue: minValue(0) },
        itemSupplierUnitName: { required, integer, minValue: minValue(0) },
        itemSupplierOrderUnitQuantity: {
          required,
          integer,
          minValue: minValue(0),
        },
        itemSupplierOrderMinimumQuantity: {
          required,
          integer,
          minValue: minValue(0),
        },
        itemSupplierDeliveryDelay: { required, integer, minValue: minValue(0) },
        itemSupplierContact: { required, integer, minValue: minValue(0) },
        itemSupplierPhone: { required, integer, minValue: minValue(0) },
        itemSupplierEmail: { required, integer, minValue: minValue(0) },
        itemSupplierCommMethod: { required, integer, minValue: minValue(0) },
        itemSupplierCommLanguage: { required, integer, minValue: minValue(0) },
        itemSupplierLink: { required, integer, minValue: minValue(0) },
      },
    };
  },
};
</script>

<template>
  <HeaderContentLayout :title="$t('importations.importations')">
    <template v-slot:header>
      <b-button type="button" variant="success" @click="saveConfig">
        {{ $t('general.save') }}
      </b-button>
    </template>

    <div>
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        color="#f1b44c"
        :width="70"
        :height="70"
        loader="dots"
        :is-full-page="false"
      >
      </loading>
      <b-container fluid>
        <b-row>
          <b-col>
            <div v-if="excelConfig != null" style="max-width: 500px">
              <h3>{{ $t('general.general') }}</h3>
              <b-container class="sub-group">
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="linesToIgnore">
                      {{ $t('importations.linesToIgnore') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.linesToIgnore.$error,
                      }"
                      id="linesToIgnore"
                      v-model="excelConfig.linesToIgnore"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.linesToIgnore" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="lineImportFlag">
                      {{ $t('importations.lineImportFlag') }}
                      <span id="popover-line-import-flag">
                        <i
                          class="fas fa-exclamation-circle text-secondary"
                          style="font-size: 1.2em"
                        ></i>
                      </span>
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.lineImportFlag.$error,
                      }"
                      id="lineImportFlag"
                      v-model="excelConfig.lineImportFlag"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.lineImportFlag" />
                    <b-popover
                      target="popover-line-import-flag"
                      triggers="hover"
                      placement="right"
                    >
                      <template #title>{{ $t('general.codes') }}</template>
                      <ul>
                        <li>0 OR false</li>
                        <li>1 OR true</li>
                      </ul>
                    </b-popover>
                  </b-col>
                </b-row>
              </b-container>
              <h3>{{ $t('general.fields') }}</h3>
              <h5>{{ $t('workOrders.workOrder') }}</h5>
              <b-container class="sub-group">
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="workOrderName">
                      {{ $t('workOrders.workOrderName') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.workOrderName.$error,
                      }"
                      id="workOrderName"
                      v-model="excelConfig.workOrderName"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.workOrderName" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="workOrderGroupItems">
                      {{ $t('workOrders.groupItems') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <div
                      class="flex-center-align"
                      style="margin-left: 6px; height: 40px"
                    >
                      <b-form-checkbox
                        :class="{
                          'is-invalid':
                            $v.excelConfig.workOrderGroupItems.$error,
                        }"
                        id="workOrderGroupItems"
                        v-model="excelConfig.workOrderGroupItems"
                        type="number"
                        size="lg"
                      >
                      </b-form-checkbox>
                      <Tooltip
                        :validations="$v.excelConfig.workOrderGroupItems"
                      />
                    </div>
                  </b-col>
                </b-row>
              </b-container>
              <h5>{{ $t('items.item') }}</h5>
              <b-container class="sub-group">
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemCode">
                      {{ $t('importations.itemCode') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.itemCode.$error,
                      }"
                      id="itemCode"
                      v-model="excelConfig.itemCode"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.itemCode" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemName">
                      {{ $t('importations.itemName') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.itemName.$error,
                      }"
                      id="itemName"
                      v-model="excelConfig.itemName"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.itemName" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemCADCAMCode">
                      {{ $t('importations.itemCADCAMCode') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.itemCADCAMCode.$error,
                      }"
                      id="itemCADCAMCode"
                      v-model="excelConfig.itemCADCAMCode"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.itemCADCAMCode" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemAccountingCode">
                      {{ $t('importations.itemAccountingCode') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.itemAccountingCode.$error,
                      }"
                      id="itemAccountingCode"
                      v-model="excelConfig.itemAccountingCode"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.itemAccountingCode" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemQuantity">
                      {{ $t('importations.itemQuantity') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.itemQuantity.$error,
                      }"
                      id="itemQuantity"
                      v-model="excelConfig.itemQuantity"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.itemQuantity" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemQuantityInWorkOrder">
                      {{ $t('importations.itemQuantityInWorkOrder') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid':
                          $v.excelConfig.itemQuantityInWorkOrder.$error,
                      }"
                      id="itemQuantityInWorkOrder"
                      v-model="excelConfig.itemQuantityInWorkOrder"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip
                      :validations="$v.excelConfig.itemQuantityInWorkOrder"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemMinQuantity">
                      {{ $t('importations.itemMinQuantity') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.itemMinQuantity.$error,
                      }"
                      id="itemMinQuantity"
                      v-model="excelConfig.itemMinQuantity"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.itemMinQuantity" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemCategoryType">
                      {{ $t('importations.itemCategoryType') }}
                      <span id="popover-cat-type">
                        <i
                          class="fas fa-exclamation-circle text-secondary"
                          style="font-size: 1.2em"
                        ></i>
                      </span>
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.itemCategoryType.$error,
                      }"
                      id="itemCategoryType"
                      v-model="excelConfig.itemCategoryType"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.itemCategoryType" />
                    <b-popover
                      target="popover-cat-type"
                      triggers="hover"
                      placement="right"
                    >
                      <template #title>{{ $t('general.codes') }}</template>
                      <ul>
                        <li>PNL: {{ $t('categories.types.panels') }}</li>
                        <li>PRD: {{ $t('categories.types.products') }}</li>
                        <li>EDB: {{ $t('categories.types.edgebands') }}</li>
                        <li>DOR: {{ $t('categories.types.doors') }}</li>
                        <li>DRW: {{ $t('categories.types.drawers') }}</li>
                        <li>HWR: {{ $t('categories.types.hardwares') }}</li>
                        <li>OTR: {{ $t('categories.types.others') }}</li>
                      </ul>
                    </b-popover>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemCategory">
                      {{ $t('importations.itemCategory') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.itemCategory.$error,
                      }"
                      id="itemCategory"
                      v-model="excelConfig.itemCategory"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.itemCategory" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemUnitType">
                      {{ $t('importations.itemUnitType') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.itemUnitType.$error,
                      }"
                      id="itemUnitType"
                      v-model="excelConfig.itemUnitType"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.itemUnitType" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemQuantityType">
                      {{ $t('importations.itemQuantityType') }}
                      <span id="popover-quantity-type">
                        <i
                          class="fas fa-exclamation-circle text-secondary"
                          style="font-size: 1.2em"
                        ></i>
                      </span>
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.itemQuantityType.$error,
                      }"
                      id="itemQuantityType"
                      v-model="excelConfig.itemQuantityType"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.itemQuantityType" />
                    <b-popover
                      target="popover-quantity-type"
                      triggers="hover"
                      placement="right"
                    >
                      <template #title>{{ $t('general.codes') }}</template>
                      <ul>
                        <li>decimal: {{ $t('items.decimal') }}</li>
                        <li>unitary: {{ $t('items.unitary') }}</li>
                      </ul>
                    </b-popover>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemSupplierCode">
                      {{ $t('importations.itemSupplierCode') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.itemSupplierCode.$error,
                      }"
                      id="itemSupplierCode"
                      v-model="excelConfig.itemSupplierCode"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.itemSupplierCode" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemSupplierName">
                      {{ $t('importations.itemSupplierName') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.itemSupplierName.$error,
                      }"
                      id="itemSupplierName"
                      v-model="excelConfig.itemSupplierName"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.itemSupplierName" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemSupplierPrice">
                      {{ $t('importations.itemSupplierPrice') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.itemSupplierPrice.$error,
                      }"
                      id="itemSupplierPrice"
                      v-model="excelConfig.itemSupplierPrice"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.itemSupplierPrice" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemSupplierUnitName">
                      {{ $t('importations.itemSupplierUnitName') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid':
                          $v.excelConfig.itemSupplierUnitName.$error,
                      }"
                      id="itemSupplierUnitName"
                      v-model="excelConfig.itemSupplierUnitName"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip
                      :validations="$v.excelConfig.itemSupplierUnitName"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemSupplierOrderUnitQuantity">
                      {{ $t('importations.itemSupplierOrderUnitQuantity') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid':
                          $v.excelConfig.itemSupplierOrderUnitQuantity.$error,
                      }"
                      id="itemSupplierOrderUnitQuantity"
                      v-model="excelConfig.itemSupplierOrderUnitQuantity"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip
                      :validations="
                        $v.excelConfig.itemSupplierOrderUnitQuantity
                      "
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemSupplierOrderMinimumQuantity">
                      {{ $t('importations.itemSupplierOrderMinimumQuantity') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid':
                          $v.excelConfig.itemSupplierOrderMinimumQuantity
                            .$error,
                      }"
                      id="itemSupplierOrderMinimumQuantity"
                      v-model="excelConfig.itemSupplierOrderMinimumQuantity"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip
                      :validations="
                        $v.excelConfig.itemSupplierOrderMinimumQuantity
                      "
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemSupplierDeliveryDelay">
                      {{ $t('importations.itemSupplierDeliveryDelay') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid':
                          $v.excelConfig.itemSupplierDeliveryDelay.$error,
                      }"
                      id="itemSupplierDeliveryDelay"
                      v-model="excelConfig.itemSupplierDeliveryDelay"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip
                      :validations="$v.excelConfig.itemSupplierDeliveryDelay"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemSupplierLink">
                      {{ $t('importations.itemSupplierLink') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.itemSupplierLink.$error,
                      }"
                      id="itemSupplierLink"
                      v-model="excelConfig.itemSupplierLink"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.itemSupplierLink" />
                  </b-col>
                </b-row>
              </b-container>
              <h5>{{ $t('importations.supplierMetadata') }}</h5>
              <b-container class="sub-group">
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="supplierName">
                      {{ $t('importations.supplierName') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.supplierName.$error,
                      }"
                      id="supplierName"
                      v-model="excelConfig.supplierName"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.supplierName" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemSupplierContact">
                      {{ $t('importations.itemSupplierContact') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.itemSupplierContact.$error,
                      }"
                      id="itemSupplierContact"
                      v-model="excelConfig.itemSupplierContact"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip
                      :validations="$v.excelConfig.itemSupplierContact"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemSupplierPhone">
                      {{ $t('importations.itemSupplierPhone') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.itemSupplierPhone.$error,
                      }"
                      id="itemSupplierPhone"
                      v-model="excelConfig.itemSupplierPhone"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.itemSupplierPhone" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemSupplierEmail">
                      {{ $t('importations.itemSupplierEmail') }}
                      <span id="popover-supplier-email">
                        <i
                          class="fas fa-exclamation-circle text-secondary"
                          style="font-size: 1.2em"
                        ></i>
                      </span>
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.itemSupplierEmail.$error,
                      }"
                      id="itemSupplierEmail"
                      v-model="excelConfig.itemSupplierEmail"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.itemSupplierEmail" />
                    <b-popover
                      target="popover-supplier-email"
                      triggers="hover"
                      placement="right"
                    >
                      <template #title>
                        {{ $t('general.multipleEmails') }}
                      </template>
                      {{
                        $t('general.useXToSeparateMultipleY')
                          .replace('{X}', ';')
                          .replace('{Y}', $t('general.emails').toLowerCase())
                      }}
                    </b-popover>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemSupplierCommMethod">
                      {{ $t('importations.itemSupplierCommMethod') }}
                      <span id="popover-comm-method">
                        <i
                          class="fas fa-exclamation-circle text-secondary"
                          style="font-size: 1.2em"
                        ></i>
                      </span>
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid':
                          $v.excelConfig.itemSupplierCommMethod.$error,
                      }"
                      id="itemSupplierCommMethod"
                      v-model="excelConfig.itemSupplierCommMethod"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip
                      :validations="$v.excelConfig.itemSupplierCommMethod"
                    />
                    <b-popover
                      target="popover-comm-method"
                      triggers="hover"
                      placement="right"
                    >
                      <template #title>{{ $t('general.codes') }}</template>
                      <ul>
                        <li>LINK: {{ $t('suppliers.emailLink') }}</li>
                        <li>PDF: {{ $t('suppliers.emailPDF') }}</li>
                        <li>PHONE: {{ $t('suppliers.phoneLink') }}</li>
                      </ul>
                    </b-popover>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="itemSupplierCommLanguage">
                      {{ $t('importations.itemSupplierCommLanguage') }}
                      <span id="popover-comm-language">
                        <i
                          class="fas fa-exclamation-circle text-secondary"
                          style="font-size: 1.2em"
                        ></i>
                      </span>
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid':
                          $v.excelConfig.itemSupplierCommLanguage.$error,
                      }"
                      id="itemSupplierCommLanguage"
                      v-model="excelConfig.itemSupplierCommLanguage"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip
                      :validations="$v.excelConfig.itemSupplierCommLanguage"
                    />
                    <b-popover
                      target="popover-comm-language"
                      triggers="hover"
                      placement="right"
                    >
                      <template #title>{{ $t('general.codes') }}</template>
                      <ul>
                        <li>EN: {{ $t('general.english') }}</li>
                        <li>FR: {{ $t('general.french') }}</li>
                      </ul>
                    </b-popover>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="supplierLink">
                      {{ $t('importations.supplierLink') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.supplierLink.$error,
                      }"
                      id="supplierLink"
                      v-model="excelConfig.supplierLink"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.supplierLink" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="supplierPaymentMethod">
                      {{ $t('importations.supplierPaymentMethod') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid':
                          $v.excelConfig.supplierPaymentMethod.$error,
                      }"
                      id="supplierPaymentMethod"
                      v-model="excelConfig.supplierPaymentMethod"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip
                      :validations="$v.excelConfig.supplierPaymentMethod"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="supplierPaymentCondition">
                      {{ $t('importations.supplierPaymentCondition') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid':
                          $v.excelConfig.supplierPaymentCondition.$error,
                      }"
                      id="supplierPaymentCondition"
                      v-model="excelConfig.supplierPaymentCondition"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip
                      :validations="$v.excelConfig.supplierPaymentCondition"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="9" class="flex-vertical-align">
                    <label for="supplierAddress">
                      {{ $t('importations.supplierAddress') }}
                    </label>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input
                      @keydown.enter.prevent="saveConfig"
                      :class="{
                        'is-invalid': $v.excelConfig.supplierAddress.$error,
                      }"
                      id="supplierAddress"
                      v-model="excelConfig.supplierAddress"
                      type="number"
                    >
                    </b-form-input>
                    <Tooltip :validations="$v.excelConfig.supplierAddress" />
                  </b-col>
                </b-row>
              </b-container>
            </div>
          </b-col>
          <b-col cols="4">
            <FilesImports />
          </b-col>
        </b-row>
      </b-container>
    </div>
  </HeaderContentLayout>
</template>

<style scoped>
input {
  text-align: center;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.sub-group {
  margin-left: 20px;
}

h5 {
  margin-left: 0;
}

.checkbox-input {
  padding: 10px;
}
</style>
